/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { theme, pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui';



/* ++++++++++ --------------- EXPORT : MENU : FILTER : HOLDER : STYLES --------------- ++++++++++ */
export default {
  filterholder: {
    // animation comes from parent filtermenu

    display: 'flex',
    width: 'max-content',
    maxHeight: pxToEm(280),


    position: 'absolute',
    top: pxToEm(74),
    zIndex: '200',

    background: theme.color.light.light.swatch,
    border: '1px solid rgb(236, 240, 247)',
    borderRadius: pxToEm(5),
    boxShadow: replacePXinStringWithEM('0px 4px 4px 0px rgba(0, 0, 0, 0.08)'),

    '& .inner': {
      padding: replacePXinStringWithEM('20px 20px 20px 20px'),
      zIndex: '200',
      background: '#fff',
      fontSize: '80%',

      '& .checkbox': {
        fontSize: '80%',
      },

      '& .name-filters': {
        display: 'flex',
        flexWrap: 'wrap'
      }
    },

    '& .carrot': {
      position: 'absolute',
      top: pxToEm(-10),
      left: pxToEm(55),
      transform: 'rotate(45deg)',
      background: theme.color.light.light.swatch,
      height: pxToEm(37),
      width: pxToEm(37),
      border: '1px solid rgb(236, 240, 247)',
      borderBottom: '0px',
      borderRight: '0px'
    }
  }
};
